import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import Button from '../components/common/Button'
import { DISPATCH_NOTE } from '../utils/copy'

export default function OrderSuccess() {
  const location = useLocation()
  const navigate = useNavigate()
  const order = location.state?.order

  // Reached without placing anything — a refresh, or a pasted URL.
  if (!order) return <Navigate to="/orders" replace />

  return (
    <section className="px-5 pt-8 pb-7 text-center">
      <div className="w-11 h-11 mx-auto grid place-items-center rounded-full bg-blush text-brand">
        <svg
          viewBox="0 0 24 24"
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="m5 13 4 4L19 7" />
        </svg>
      </div>

      <p className="mt-4 text-label font-semibold uppercase text-ink-3">Order placed</p>

      {/* The number is the whole screen. Everything else is caption. */}
      <p className="mt-1.5 font-display font-bold text-display-xl tabular-nums text-brand">
        {order.orderId}
      </p>

      {/* "They will assign a rider shortly" was wrong, and not by a little: nobody
          assigns anything. Dispatch is automatic and runs inside the placement request,
          so by the time this screen renders a rider has already been chosen and their
          phone has already buzzed. `dispatchState` says which of the five things is
          actually true, and `exhausted` is the one the customer may want to act on.

          The wording lives in `copy.js` now, shared with `OrderDetail`. This screen used
          to carry its own copy of it, in English and missing `scheduled` — which fell
          through to "we are finding you a rider" on an order deliberately offered to
          nobody yet.

          The second sentence is Tagalog here rather than in `copy.js` because the rest of
          this screen is still English; it moves with them in the app-wide sweep. What it
          may not do is sit in English inside a paragraph that now opens in Tagalog. */}
      <p className="mt-2.5 text-body text-ink-2">
        {DISPATCH_NOTE[order.dispatchState] ?? DISPATCH_NOTE.unassigned}{' '}
        Banggitin ang numerong ito kung magme-message ka sa {order.partner.businessName}.
      </p>

      <div className="flex flex-col gap-2.5 mt-6">
        <Button onClick={() => navigate(`/orders/${order.orderId}`)} className="w-full">
          Track this order
        </Button>

        <Button variant="ghost" onClick={() => navigate('/home')} className="w-full">
          Back to services
        </Button>
      </div>
    </section>
  )
}
